class Path {

  constructor({
    points = [],
  }) {
    this.points = points;
  }

  set({
    points = [],
  }) {
    this.points = points;
  }

}

export {
  Path,
};
